module.exports = __webpack_public_path__ + "img/menu_img2.3d86c8e6.png";